(function () {
  'use strict';

  angular.module('ringbaPortal').component('campaignPayouts', {
    bindings: {
      payoutsContainerSelector: '@',
      currentCampaign: '<',
      readOnly: '<',
      onSave: '&'
    },
    controller: CampaignPayoutsController,
    controllerAs: 'vm',
    templateUrl: '/scripts/components/campaigns/campaign-payouts/campaign-payouts.view.html'
  });

  function CampaignPayoutsController(
    $filter,
    accountsService,
    campaignPayoutService,
    toaster,
    utils
  ) {
    'ngInject';

    const vm = this;

    vm.$onInit = onInit;
    vm.$onChanges = onChanges;
    vm.batchUpdatePayoutSettings = batchUpdatePayoutSettings;

    function onInit() {
      vm.payoutSaveConfirmation = $filter('translate')('PUBLISHER_PAYOUT_CHANGE_CONFIRM');
      vm.notifyPubLabel = $filter('translate')('PUBLISHER_PAYOUT_CHANGE_NOTIFY');
      vm.updatePayoutButtonText = $filter('translate')('PUBLISHER_DEFAULT_PAYOUT_UPDATE_BUTTON');
      vm.unsavedChangesText = $filter('translate')('PUBLISHER_DEFAULT_PAYOUT_UNSAVED_CHANGES');
    }

    function onChanges() {
      vm.defaultPayouts = vm.currentCampaign && vm.currentCampaign.defaultPayouts ? angular.copy(vm.currentCampaign.defaultPayouts) : [];
    }

    function batchUpdatePayoutSettings(payoutSettings, notifyPublishers) {
      return campaignPayoutService.batchUpdatePayoutSettings(accountsService.currentAccountId, vm.currentCampaign.id, payoutSettings, notifyPublishers)
        .then(function () {
          let message = 'PUBLISHER_DEFAULT_PAYOUT_CHANGE_NOTIFY_SUCCESS';
          if (!notifyPublishers) {
            message = 'PUBLISHER_DEFAULT_PAYOUT_CHANGE_NOT_NOTIFY_SUCCESS';
          }
          toaster.pop('success', $filter('translate')(message));
          return vm.onSave();
        })
        .catch(utils.errorHandler);
    }

  }
})();
